var _defs, _path, _g, _g2, _rect, _rect2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgExclusionHand(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Calque_1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 150 100.01",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1 {\n        fill: #47464b;\n      }\n\n      .cls-2 {\n        fill: none;\n        stroke: #47464b;\n        stroke-linecap: round;\n        stroke-linejoin: round;\n        stroke-width: 1.41px;\n      }\n    "))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M75,20.57c13.99,0,25.33,11.34,25.33,25.33s-11.34,25.33-25.33,25.33-25.33-11.34-25.33-25.33c0-6.18,2.22-11.85,5.9-16.25"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M66.47,50.48v-4.65h-4.69v-3.21h4.69v-4.65h3.13v4.65h4.7v3.21h-4.7v4.65h-3.13Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M88,49.87v3.19h-12.02c.13-1.2.52-2.35,1.17-3.42.65-1.08,1.94-2.51,3.86-4.29,1.55-1.44,2.49-2.42,2.84-2.93.47-.71.71-1.41.71-2.1,0-.76-.21-1.35-.62-1.76-.41-.41-.98-.62-1.7-.62s-1.29.22-1.71.65c-.42.43-.67,1.15-.73,2.15l-3.42-.34c.2-1.89.84-3.24,1.92-4.07,1.07-.82,2.42-1.23,4.03-1.23,1.77,0,3.15.48,4.16,1.43,1.01.95,1.51,2.14,1.51,3.55,0,.81-.14,1.57-.43,2.3-.29.73-.75,1.49-1.37,2.29-.42.53-1.16,1.29-2.25,2.28-1.08.99-1.77,1.65-2.06,1.98-.29.33-.52.64-.7.95h6.81Z"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M61.72,91.11l1.86-8.91h1.52l-.31,1.47c.57-.63,1.07-1.07,1.51-1.31.44-.24.93-.36,1.45-.36.55,0,1.02.15,1.39.44.37.29.62.7.73,1.23.45-.56.93-.98,1.43-1.25.5-.28,1.03-.42,1.58-.42.74,0,1.3.18,1.67.53.37.35.56.85.56,1.49,0,.27-.06.73-.19,1.36l-1.2,5.74h-1.52l1.23-5.89c.11-.48.16-.83.16-1.03,0-.29-.09-.52-.28-.69s-.44-.25-.78-.25c-.45,0-.91.14-1.38.41s-.83.63-1.1,1.08c-.26.44-.49,1.13-.68,2.05l-.91,4.32h-1.52l1.26-6.02c.09-.41.13-.7.13-.87,0-.29-.09-.53-.27-.7-.18-.18-.42-.27-.71-.27-.43,0-.88.14-1.35.41-.47.27-.86.66-1.15,1.15s-.54,1.19-.73,2.09l-.88,4.21h-1.52Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M75.98,91.11l1.86-8.91h1.52l-1.86,8.91h-1.52ZM78.2,80.52l.36-1.72h1.51l-.36,1.72h-1.51Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M79.86,91.11l1.86-8.91h1.38l-.33,1.55c.6-.61,1.16-1.05,1.68-1.33s1.05-.42,1.59-.42c.72,0,1.29.2,1.7.59.41.39.62.91.62,1.57,0,.33-.07.85-.22,1.56l-1.13,5.4h-1.52l1.18-5.65c.12-.55.18-.95.18-1.22,0-.3-.1-.54-.31-.72-.2-.18-.5-.28-.89-.28-.78,0-1.47.28-2.08.84-.61.56-1.05,1.52-1.34,2.88l-.86,4.15h-1.52Z"
  }))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 73.96,
    y: 9.73,
    width: 2.09,
    height: 11.41
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 71.18,
    y: 8.9,
    width: 7.63,
    height: 4.45
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgExclusionHand);
export default __webpack_public_path__ + "static/media/exclusion_hand.de09251d3255433cbfdf9b6f4d6fd91a.svg";
export { ForwardRef as ReactComponent };